var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{staticClass:"smc-parallax",attrs:{"src":_vm.src}},[_c('div',{staticClass:"smc-transparent-back",style:(("background-color: " + _vm.backgroundColor + "; opacity: " + _vm.backgroundOpacity + ";"))})])}
var staticRenderFns = []

export { render, staticRenderFns }